export enum RecommendationType {
    LANDING_PAGE = "landing_page",
    RECENTLY_VIEWED = "recently_viewed",
    FOR_YOU = "for_you",

    // Needs product_id(s)
    RELATED = "related",
    CROSS_SELL = "cross_sell"

    // Not in use right now from POC, but keep for now
    // AFTER_BASKET = "after_basket",
    // CHECKOUT = "checkout",
    // SEARCH = "search"
}
